import { Navigate, useLocation, useSearchParams } from 'react-router-dom';

/**
 * A wrapper around React Router's `Navigate` that preserves all current URL search
 * parameters when redirecting. React Router's `Navigate` doesn't preserve query params
 * by default, which breaks version switching (`?v=2`/`?v=3`) during MSR3 migration.
 *
 * Use this instead of `Navigate` when you need to maintain search parameters through redirects.
 */
export const NavigateWithParams = ({
  omitParams = [],
  to,
  ...rest
}: React.ComponentProps<typeof Navigate> & {
  /** Params not to carry over, such as one the redirect itself has acted on. */
  omitParams?: string[];
}) => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const params = new URLSearchParams(searchParams);

  omitParams.forEach((param) => params.delete(param));

  const search = params.toString();

  return (
    <Navigate
      {...rest}
      state={rest.state ?? location.state}
      to={`${to}?${search}`}
    />
  );
};
